import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['body','submit'];
  static values = {bodyheight:Number};

  onScroll(event){
    if((this.bodyTarget.scrollHeight - this.bodyheightValue) < this.bodyTarget.scrollTop){
      this.submitTarget.disabled = false;
    }
  }
}
